(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bb-footer-accordion')) {
    customElements.define('bb-footer-accordion', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.mobile = window.matchMedia('(max-width: 760px)');
        const sync = () => {
          this.querySelectorAll('.bb-footer__accordion').forEach(details => {
            const summary = details.querySelector('.bb-footer__summary');
            const hasFeedback = details.querySelector('.bb-footer__success, .bb-footer__error');
            const hasFocus = details.contains(document.activeElement);
            details.open = !this.mobile.matches || Boolean(hasFeedback) || hasFocus;
            if (this.mobile.matches) summary.removeAttribute('tabindex');
            else summary.setAttribute('tabindex', '-1');
          });
        };
        this.addEventListener('click', event => {
          if (!this.mobile.matches && event.target.closest('.bb-footer__summary')) event.preventDefault();
        }, options);
        this.addEventListener('toggle', event => {
          if (!this.mobile.matches && event.target.matches('.bb-footer__accordion') && !event.target.open) event.target.open = true;
        }, { ...options, capture: true });
        this.addEventListener('shopify:block:select', event => {
          const details = event.target.querySelector('.bb-footer__accordion');
          if (details) details.open = true;
        }, options);
        this.mobile.addEventListener('change', sync, options);
        sync();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
